import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'star-rating',
  templateUrl: './start-rating.component.html',
  styleUrls: ['./start-rating.component.css']
})
export class StarRatingComponent {
  @Input() max: number;
  @Output() onRating = new EventEmitter<Number>();

  maxItem: any[];
  @Input() ratedCount: number;
  @Input() readonly: boolean;
  @Input() showLabel: boolean;
  arrayRatingLabels: Array<String> = ['Pessimo', 'Scarso', 'Nella media', 'Molto buono', 'Eccellente'];

  constructor() {
    this.ratedCount = 0;
    this.readonly = false;
    this.showLabel = false;
  }

  ngOnInit() {
    this.maxItem = [];
    for (var i = 0; i < this.max; i++) {
      this.maxItem.push(i + 1);
    }
  }
  toggleRating(s: number) {
    if(!this.readonly){
      this.ratedCount = s;
      this.onRating.emit(this.ratedCount);
    }
  }

}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/start-rating/start-rating.component.ts